import type { FC } from 'react';

type Props = {
  fillColor?: string;
  emptyColor?: string;
  className?: string;
  label?: string;
};

export const HalfStarIcon: FC<Props> = ({
  fillColor = '#ffc346',
  emptyColor = '#dadde0',
  className = 'w-4 h-4',
  label
}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={label}
    >
      <path
        d="M4.77687 17.032C4.02031 17.4884 3.08694 16.8112 3.28606 15.9504L4.24285 11.8141C4.32632 11.4533 4.20349 11.0758 3.92363 10.8332L0.713503 8.0501C0.0459742 7.47137 0.401925 6.37468 1.28209 6.29827L5.5284 5.92967C5.89758 5.89762 6.21877 5.66405 6.36303 5.32271L8.00742 1.43199C8.35156 0.617723 9.5055 0.617722 9.84964 1.43199L11.494 5.32271C11.6383 5.66405 11.9595 5.89762 12.3287 5.92967L16.575 6.29827C17.4551 6.37468 17.8111 7.47137 17.1436 8.0501L13.9334 10.8332C13.6536 11.0758 13.5307 11.4533 13.6142 11.8141L14.571 15.9504C14.7701 16.8112 13.8367 17.4884 13.0802 17.032L9.44506 14.8392C9.12737 14.6475 8.72968 14.6475 8.41199 14.8392L4.77687 17.032Z"
        fill={emptyColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.92773 0.921366C8.92773 0.866107 8.88281 0.82082 8.82781 0.82621C8.4884 0.859477 8.16404 1.0614 8.00742 1.43199L6.36303 5.32271C6.21877 5.66405 5.89758 5.89762 5.5284 5.92967L1.28209 6.29827C0.401925 6.37467 0.0459742 7.47137 0.713503 8.0501L3.92363 10.8332C4.20349 11.0758 4.32632 11.4533 4.24285 11.8141L3.28606 15.9504C3.08694 16.8112 4.02031 17.4884 4.77687 17.032L8.41199 14.8392C8.54103 14.7613 8.68327 14.7151 8.82798 14.7005C8.8829 14.695 8.92773 14.6507 8.92773 14.5955V0.921366Z"
        fill={fillColor}
      />
    </svg>
  );
};
